import { useEffect, useState } from 'react';
import { useAccount } from 'wagmi';

export const useWalletAgreement = () => {
  const { address, isConnected } = useAccount();
  const [hasAccepted, setHasAccepted] = useState(false);

  useEffect(() => {
    if (!address || !isConnected) {
      setHasAccepted(false);
      return;
    }

    const stored = localStorage.getItem('acceptedWallets');
    const usedAddresses = stored ? JSON.parse(stored) : [];
    setHasAccepted(usedAddresses.includes(address));
  }, [address, isConnected]);

  const acceptAgreement = () => {
    const stored = localStorage.getItem('acceptedWallets');
    const usedAddresses = stored ? JSON.parse(stored) : [];

    if (!usedAddresses.includes(address) && !!address) {
      usedAddresses.push(address);
      localStorage.setItem('acceptedWallets', JSON.stringify(usedAddresses));
    }

    setHasAccepted(true);
  };

  return { hasAccepted, acceptAgreement };
};
